<template>
  <v-container class="container">
    <v-card class="intro-page" elevation="4">
      <div class="intro-page__illustration">
        <HostingSuspendedIllustration />
      </div>
      <h4 class="intro-page__title">
        {{ $t("general.instancesSuspended") }}
      </h4>
      <div class="intro-page__desc p-lg">
        {{ $t("general.instancesSuspendedDescription") }}
      </div>
      <div class="intro-page__actions">
        <v-btn
          v-if="suspendedService.plan_upgrade_link"
          :href="suspendedService.plan_upgrade_link"
          target="_blank"
          color="orange"
          x-large
          elevation="0"
        >
          <span class="white--text">
            {{ $t("general.upgradePlan") }}
          </span>
        </v-btn>
        <v-btn
          v-if="supportUrl"
          :href="supportUrl"
          target="_blank"
          outlined
          x-large
          elevation="0"
        >
          <span class="text--gray-darken1">
            {{ $t("general.contactSupport") }}
          </span>
        </v-btn>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import HostingSuspendedIllustration from "./illustrations/hosting/hosting-suspended-illustration.vue";

export default {
  props: {
    suspendedService: Object,
  },
  components: {
    HostingSuspendedIllustration,
  },
  computed: {
    supportUrl() {
      return this.$store.state.home?.app?.support_link;
    },
  },
};
</script>
